import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "24x24/reload"
  }, React.createElement("path", {
    id: "Union",
    d: "M19.8834 8.46601L13.1527 9.76679L12.7749 7.81179L16.6463 7.0636C15.8563 6.47466 14.9481 6.0478 13.9743 5.81609C12.419 5.44597 10.7833 5.59447 9.32117 6.23904C7.859 6.88362 6.65243 7.9881 5.88861 9.38106C5.12481 10.774 4.84658 12.3772 5.09656 13.9421C5.34653 15.5069 6.11073 16.946 7.2705 18.0365C8.43029 19.127 9.92116 19.8082 11.5121 19.974C13.1032 20.1399 14.7054 19.7811 16.0702 18.953C17.4349 18.1249 18.4856 16.8739 19.0593 15.3942L20.9349 16.1113C20.2029 17.9993 18.8625 19.5951 17.1218 20.6514C15.381 21.7077 13.3367 22.1657 11.3058 21.954C9.27481 21.7422 7.37074 20.8725 5.88911 19.4794C4.40748 18.0863 3.43142 16.248 3.1122 14.2496C2.79298 12.2514 3.14842 10.205 4.12288 8.42792C5.09732 6.65084 6.63644 5.24201 8.50158 4.41979C10.3667 3.59755 12.4541 3.40775 14.4399 3.8803C15.4051 4.10998 16.3201 4.48992 17.1533 5.00039L16.5992 2.18723L18.5701 1.79907L19.8834 8.46601Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Reload24 } from '@cian/ui-kit/icons';`, <br />
 * где 24 - это размер иконки в пикселях.
 */

export var Reload24 = createIcon(IconComponent);